import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { AuthAPI } from '../../api/client';
import {
  AuthLayout, ErrorText, InfoText, Turnstile, useAuthConfig,
  input, label, button, linkRow, linkStyle,
} from './authShared';

/** Request a password-reset code. Always reports success (enumeration-safe) and
 *  routes to the reset screen. */
export default function ForgotPassword() {
  const cfg = useAuthConfig();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [email, setEmail] = useState(params.get('email') || '');
  const [captcha, setCaptcha] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const reason = params.get('reason') === 'reset_required'
    ? 'A password reset is required for this account. Enter your email to receive a code.'
    : 'Enter your email and we’ll send a reset code.';

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!email.trim()) { setError('Enter your email.'); return; }
    if (cfg?.captchaSiteKey && !captcha) { setError('Please complete the CAPTCHA.'); return; }
    setBusy(true);
    const r = await AuthAPI.forgotPassword(email.trim(), captcha);
    setBusy(false);
    if (r.ok) { nav(`/reset-password?email=${encodeURIComponent(email.trim())}`); return; }
    setError(r.message || 'Something went wrong. Please try again.');
  };

  return (
    <AuthLayout title="Reset your password" subtitle={reason}>
      <form onSubmit={submit}>
        <label style={label}>Email
          <input style={input} type="email" autoComplete="username" value={email}
                 onChange={e => setEmail(e.target.value)} autoFocus />
        </label>
        {cfg?.captchaSiteKey && <Turnstile siteKey={cfg.captchaSiteKey} onToken={setCaptcha} />}
        <ErrorText>{error}</ErrorText>
        <button type="submit" style={button} disabled={busy}>{busy ? 'Sending…' : 'Send reset code'}</button>
      </form>
      <p style={linkRow}><Link to="/login" style={linkStyle}>Back to sign in</Link></p>
    </AuthLayout>
  );
}
